import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import {Outlet} from 'react-router-dom';

export const AuthLayout = () => {
    return (
        <Grid container component="main" sx={{height: '100vh'}}>
            <CssBaseline />
            <Grid item xs={12} sm={12} md={12} component={Paper} square>
                <div
                    style={{
                        overflowY: 'auto',
                    }}
                >
                    <Outlet />
                </div>
            </Grid>
        </Grid>
    );
};

export default AuthLayout;
